import { parseCalendarDate } from "./validation.js";
function birthdayWrite(value) {
  const date = value === null || value === "" ? null : parseCalendarDate(value);
  return { birthdayDate: date, birthday: date ? `${date}T00:00:00.000Z` : null };
}
function birthdayProfileWrite(input) {
  if (Object.hasOwn(input, "birthdayDate")) {
    const result = birthdayWrite(input.birthdayDate === null ? null : parseCalendarDate(input.birthdayDate));
    if (Object.hasOwn(input, "birthday") && input.birthday !== result.birthday && input.birthday !== result.birthdayDate && !(result.birthday === null && input.birthday === "")) throw new Error("Birthday fields must describe the same calendar date.");
    return result;
  }
  if (!Object.hasOwn(input, "birthday")) return {};
  const value = input.birthday;
  if (value === null || value === "") return birthdayWrite(null);
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return birthdayWrite(value);
  if (!(value instanceof Date) && (typeof value !== "string" || !/T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value)) || !Number.isFinite(new Date(value).getTime())) throw new Error("Birthday must be a calendar date or a legacy timestamp with an explicit offset.");
  return { birthday: value, birthdayDate: null };
}
function birthdayForDisplay(user) {
  if (user.birthdayDate != null) {
    try {
      return parseCalendarDate(user.birthdayDate);
    } catch {
      return null;
    }
  }
  if (typeof user.birthday !== "string") return null;
  const value = user.birthday;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value) || /^\d{4}-\d{2}-\d{2}T/.test(value)) {
    try {
      return parseCalendarDate(value.slice(0, 10));
    } catch {
      return null;
    }
  }
  return null;
}
export {
  birthdayForDisplay,
  birthdayProfileWrite,
  birthdayWrite
};
//# sourceMappingURL=birthday.js.map
